import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let el = this.el.querySelector('#season');
        el.addEventListener('change', (e) => {
            this.changeClass(e.target);
        });
    }

   changeClass(selectElement) {
        var selectedOption = selectElement.value;
        var element = document.querySelector('.o-form-big-select');
        var elementText = document.querySelector('.o-form-big-select__text span');
        var parent = document.querySelector('.c-slider__section div');
        var themeClasseEte = document.querySelector('.c-slider__section').getAttribute('data-ete');
        var themeClasseHiver = document.querySelector('.c-slider__section').getAttribute('data-hiver');
        var sliderItemEte = document.querySelector('.c-slider-selector__item.-item-ete');
        var sliderItemHiver = document.querySelector('.c-slider-selector__item.-item-hiver');
        var colorChangeElement = document.querySelector('.o-color-change.-slider'); // Ajouté

        // Remove all classes from the parent
        parent.className = '';
        if (selectedOption == 'hiver') {
            element.classList.add('-hiver');
            element.classList.remove('-ete');
            elementText.innerText = 'Hiver';
            themeClasseHiver.split(' ').forEach(function(className) {
                parent.classList.add(className);
            });
            sliderItemHiver.classList.add('-is-active');
            sliderItemEte.classList.remove('-is-active');
        } else if (selectedOption == 'été') {
            element.classList.add('-ete');
            element.classList.remove('-hiver');
            elementText.innerText = 'Été';
            themeClasseEte.split(' ').forEach(function(className) {
                parent.classList.add(className);
            });
            sliderItemHiver.classList.remove('-is-active');
            sliderItemEte.classList.add('-is-active');
        }

        // Mettez à jour data-logo-colors en fonction de la nouvelle classe
        var newLogoColors;
        if (parent.className.includes('u-bg-color-1-dark u-color-1')) {
            newLogoColors = 'logo-icon-is-color-1, logo-text-is-color-white';
        } else if (parent.className.includes('u-bg-color-2-darker u-color-2')) {
            newLogoColors = 'logo-icon-is-color-2, logo-text-is-color-white';
        } else if (parent.className.includes('u-bg-color-3-darker u-color-3')) {
            newLogoColors = 'logo-icon-is-color-3, logo-text-is-color-white';
        } else if (parent.className.includes('u-bg-color-4-darker u-color-4')) {
            newLogoColors = 'logo-icon-is-color-4, logo-text-is-color-white';
        } else {
            newLogoColors = 'logo-icon-is-color-1, logo-text-is-color-white';
        }
        newLogoColors = newLogoColors;
        colorChangeElement.setAttribute('data-logo-colors', newLogoColors); // Modifié
    }
}
